import React from 'react';

import { Button } from '../../../../../components';

const Buttons = ({ buttons }) => {

  return (
    <div className="NodeMunicipality--full__buttons">
      {buttons.map((button, i) => {
        const href = button.get('alias', button.get('uri'));

        return (
          <Button
            key={button.get('uri')}
            href={href}
            secondary={buttons.size === i + 1}
            size={buttons.size === i + 1 ? 'small' : 'large'}
            icon={button.get('alias') ? 'arrow' : 'outbound-link'}
          >
            {button.get('title')}
          </Button>
        );
      })}
    </div>
  );
};

export default Buttons;
